import {isPokiHost} from './platformDefaults.js';
import {isMobile} from './device.js';

export const DEFAULT_GAME_VERSION = '1.5.0';
export const LEVEL_VERSION_ERROR = 'This level requires a newer version of JollyWorld. Please update the game.';
export const LEVEL_MOBILE_ERROR = "This level doesn't work on phones and tablets. Play it on a computer instead.";

const parseVersion = value => {
    if(typeof value !== 'string') return null;
    const normalized = value.trim();
    if(!/^[vV]?[0-9]{1,9}(\.[0-9]{1,9}){0,2}$/.test(normalized)) return null;
    const parts = normalized.replace(/^[vV]/, '').split('.').map(Number);
    while(parts.length < 3) parts.push(0);
    return parts;
};

export const isLevelCompatible = (level, clientVersion = __VERSION__) => {
    const client = parseVersion(clientVersion) || parseVersion(DEFAULT_GAME_VERSION);
    const build = level?.game_build;
    const missingBuild = build == null || (typeof build === 'string' && build.trim() === '');
    const required = parseVersion(missingBuild ? DEFAULT_GAME_VERSION : build);
    if(!required) return false;
    for(let i = 0; i < client.length; i++) {
        if(required[i] !== client[i]) return required[i] < client[i];
    }
    return true;
};

// Query parameters also separate cached responses for different clients.
// Released clients omit game_version; the backend keeps those requests at 1.5.0.
// On Poki and on mobile the backend leaves out levels an admin hid there.
export const withClientParams = (url, version = __VERSION__, onPoki = isPokiHost(), mobile = isMobile()) => {
    const result = new URL(url);
    result.searchParams.set('game_version', version);
    if(onPoki) result.searchParams.set('platform', 'poki');
    if(mobile) result.searchParams.set('device', 'mobile');
    return result.href;
};
